import { jsonLocalStorageCreator } from '@pa/cache-service';

const localStorageService = jsonLocalStorageCreator(window.localStorage);

export { localStorageService };
